<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
<!--        <Toolbar class="p-mb-4">-->
<!--          <template #start>-->
<!--            <div style="font-size: 1.4em; color: inherit" class="p-mr-3">{{ $t('videoTutorialsLabel') }}</div>-->
<!--          </template>-->
<!--          <template #end>-->
<!--            <CustomDropdown id="video-tutorials-language"-->
<!--                            style="width: 180px; max-width: 100%"-->
<!--                            v-model="selectedVideoLanguage"-->
<!--                            :options="videoLanguages"-->
<!--                            data-key="value"-->
<!--                            :showClear="false"-->
<!--                            :aria-label="$t('Select language')">-->
<!--              <template #value="slotProps">-->
<!--                <span v-if="slotProps.value">{{ slotProps.value.name }}</span>-->
<!--                <span v-else>{{ $t('Select language') }}</span>-->
<!--              </template>-->
<!--              <template #option="slotProps">-->
<!--                <span>{{ slotProps.option.name }}</span>-->
<!--              </template>-->
<!--            </CustomDropdown>-->
<!--          </template>-->
<!--        </Toolbar>-->

<!--        <DesktopDataTable v-if="visibleTutorials.length"-->
<!--                          class="p-mb-2"-->
<!--                          :showHeader="false"-->
<!--                          :dataTableIsLoading="false"-->
<!--                          :itemsArrayIsEmpty="!visibleTutorials.length"-->
<!--                          :sort="{ column: 'number', direction: '' }"-->
<!--                          :showSearchInput="false"-->
<!--                          :showButtons="false"-->
<!--                          :actionButtonsCount="0"-->
<!--                          :headers="[-->
<!--                            { name: 'number', title: '#', width: '80px', sortable: false },-->
<!--                            { name: 'title', title: $t('videoTutorialsLessonLabel'), minWidth: '400px', sortable: false },-->
<!--                            { name: 'duration', title: $t('Duration'), width: '160px', sortable: false },-->
<!--                            { name: 'updated', title: $t('Updated'), width: '160px', sortable: false },-->
<!--                          ]">-->
<!--          <template #body>-->
<!--            <tr v-for="tutorial in visibleTutorials" :key="tutorial.id">-->
<!--              <td>{{ tutorial.number }}</td>-->
<!--              <td class="word-break">-->
<!--                <a v-if="!isPlaceholder(tutorial.video.url)"-->
<!--                   :href="tutorial.video.url"-->
<!--                   target="_blank"-->
<!--                   rel="noopener noreferrer"-->
<!--                   draggable="false">{{ tutorial.video.title }}</a>-->
<!--                <span v-else>{{ tutorial.video.title }}</span>-->
<!--                <span v-if="isPlaceholder(tutorial.video.url)" class="tutorial-coming-soon p-ml-2">{{ ui.comingSoon }}</span>-->
<!--                <small v-if="tutorial.video.description" class="p-d-block p-mt-1 p-text-secondary">{{ tutorial.video.description }}</small>-->
<!--              </td>-->
<!--              <td class="nowrap">-->
<!--                <span v-if="formatDuration(tutorial.video.durationSeconds)">-->
<!--                  {{ formatDuration(tutorial.video.durationSeconds) }}-->
<!--                </span>-->
<!--                <i v-else class="ti-minus"/>-->
<!--              </td>-->
<!--              <td class="nowrap">-->
<!--                <time v-if="validDate(tutorial.video.updatedAt)" :datetime="tutorial.video.updatedAt">{{ formatDate(tutorial.video.updatedAt) }}</time>-->
<!--                <i v-else class="ti-minus"/>-->
<!--              </td>-->
<!--            </tr>-->
<!--          </template>-->
<!--        </DesktopDataTable>-->
<!--        <div v-elses-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoTutorials',
  data() {
    return {
      selectedLanguage: null,
      videoLanguages: [
        { value: 'ru', name: 'RU – Русский' },
        { value: 'et', name: 'ET – Eesti' },
      ],
      // Одна запись = один урок; опубликованные версии содержат URL и дату.
      // Для будущей версии URL, длительность и дата остаются null.
      // tutorials: [
      //   {
      //     id: 1, number: 1,
      //     videos: {
      //       "ru": {
      //         "title": "Знакомство с системой",
      //         "description": "Основные разделы программы, настройки аккаунта и локации, раздел помощи.",
      //         "url": "https://customer-26tnni0z8wx8ptig.cloudflarestream.com/7ba4e0936a9ac66050df804dc0b0ac2f/watch",
      //         "durationSeconds": 375,
      //         "updatedAt": "2026-10-22"
      //       },
      //       "et": {
      //         "title": "Süsteemi tutvustus",
      //         "description": "Programmi põhijaotised, konto ja asukoha seaded ning abi jaotis.",
      //         "url": "https://customer-26tnni0z8wx8ptig.cloudflarestream.com/73a7d0576f17a6e6315ad6fa0e5698ab/watch",
      //         "durationSeconds": 388,
      //         "updatedAt": "2026-10-22"
      //       }
      //     },
      //   },
      //   {
      //     id: 2, number: 2,
      //     videos: {
      //       "ru": {
      //         "title": "Настройка локации",
      //         "description": "Рабочее время, документы, наценки, оформление и уведомления.",
      //         "url": "https://customer-26tnni0z8wx8ptig.cloudflarestream.com/346771bbbca2926a96806ff5fca0eec9/watch",
      //         "durationSeconds": 662,
      //         "updatedAt": "2026-10-22"
      //       },
      //       "et": {
      //         "title": "Asukoha seadistamine",
      //         "description": "Tööaeg, dokumendid, juurdehindlused, kujundus ja teavitused.",
      //         "url": "https://customer-26tnni0z8wx8ptig.cloudflarestream.com/bcaf8eb3e2b1b7d50384ee4f288f29d8/watch",
      //         "durationSeconds": 668,
      //         "updatedAt": "2026-10-22"
      //       }
      //     },
      //   },
      //   {
      //     id: 3, number: 3,
      //     videos: {
      //       "ru": {
      //         "title": "Справочники и складские товары",
      //         "description": "Посты, поставщики, услуги, складские товары и шаблоны работ.",
      //         "url": "https://customer-26tnni0z8wx8ptig.cloudflarestream.com/b291f2ae8dc1ab7ca9668d37858991bb/watch",
      //         "durationSeconds": 705,
      //         "updatedAt": "2026-10-22"
      //       },
      //       "et": {
      //         "title": "Registrid ja laokaubad",
      //         "description": "Tööpostid, tarnijad, teenused, laokaubad ja töömallid.",
      //         "url": "https://customer-26tnni0z8wx8ptig.cloudflarestream.com/778935d8be7ea945e64e8e41ec493c29/watch",
      //         "durationSeconds": 674,
      //         "updatedAt": "2026-10-22"
      //       }
      //     },
      //   },
      //   {
      //     id: 4, number: 4,
      //     videos: {
      //       "ru": {
      //         "title": "Сотрудники и доступы",
      //         "description": "Добавление сотрудников, назначение ролей и настройка доступа.",
      //         "url": "https://customer-26tnni0z8wx8ptig.cloudflarestream.com/adce190da2f18c4b9790f72556436d27/watch",
      //         "durationSeconds": 784,
      //         "updatedAt": "2026-10-22"
      //       },
      //       "et": {
      //         "title": "Töötajad ja ligipääsud",
      //         "description": "Töötajate lisamine, rollide määramine ja ligipääsude seadistamine.",
      //         "url": "https://customer-26tnni0z8wx8ptig.cloudflarestream.com/21b485117c9257574db13318cbe6699e/watch",
      //         "durationSeconds": 767,
      //         "updatedAt": "2026-10-22"
      //       }
      //     },
      //   },
      //   {
      //     id: 5, number: 5,
      //     videos: {
      //       "ru": {
      //         "title": "Настройки почты",
      //         "description": "Подключение почты, доступы, подписи, отправка и получение писем.",
      //         "url": "https://customer-26tnni0z8wx8ptig.cloudflarestream.com/c149273f13fbd76132ed691eba72bee2/watch",
      //         "durationSeconds": 450,
      //         "updatedAt": "2026-10-22"
      //       },
      //       "et": {
      //         "title": "E-posti seaded",
      //         "description": "E-posti ühendamine, ligipääsud, allkirjad ning kirjade saatmine ja vastuvõtmine.",
      //         "url": "https://customer-26tnni0z8wx8ptig.cloudflarestream.com/b392d2b60d8de9c0348932fbd65107dd/watch",
      //         "durationSeconds": 491,
      //         "updatedAt": "2026-10-22"
      //       }
      //     },
      //   },
      //   {
      //     id: 6, number: 6,
      //     videos: {
      //       "ru": {
      //         "title": "Первый заказ",
      //         "description": "Клиент и автомобиль, создание заказа, статусы, счёт, оплата и архив.",
      //         "url": "https://customer-26tnni0z8wx8ptig.cloudflarestream.com/20cd41d3bfe65341be8407729a447f26/watch",
      //         "durationSeconds": 1336,
      //         "updatedAt": "2026-10-22"
      //       },
      //       "et": {
      //         "title": "Esimene tellimus",
      //         "description": "Klient ja sõiduk, tellimuse loomine, olekud, arve, makse ja arhiiv.",
      //         "url": "https://customer-26tnni0z8wx8ptig.cloudflarestream.com/3efc6748aed53213ba28e7b752984a9e/watch",
      //         "durationSeconds": 1366,
      //         "updatedAt": "2026-10-22"
      //       }
      //     },
      //   },
      //   {
      //     id: 7, number: 7,
      //     videos: {
      //       "ru": {
      //         "title": "Работа с заказами",
      //         "description": "Позиции заказа, начисления мастерам, планировщик, файлы, напоминания, отмена и архив.",
      //         "url": "https://customer-26tnni0z8wx8ptig.cloudflarestream.com/0a8a0d0e900a4d070e56861a9a2fc2c9/watch",
      //         "durationSeconds": 1755,
      //         "updatedAt": "2026-10-22"
      //       },
      //       "et": {
      //         "title": "Tellimustega töötamine",
      //         "description": "Tellimuse positsioonid, tehnikute tasud, tööde planeerimine, failid, meeldetuletused, tühistamine ja arhiiv.",
      //         "url": "https://customer-26tnni0z8wx8ptig.cloudflarestream.com/f05b02e0e02104e962f7e7425aadc7b6/watch",
      //         "durationSeconds": 1438,
      //         "updatedAt": "2026-10-22"
      //       }
      //     },
      //   },
      //   {
      //     id: 8, number: 8,
      //     videos: {
      //       "ru": {
      //         "title": "Позиции под заказ и возвраты",
      //         "description": "Статусы и количество позиций, возвраты поставщику и на склад, отмена возврата.",
      //         "url": null,
      //         "durationSeconds": null,
      //         "updatedAt": null
      //       },
      //       "et": {
      //         "title": "Tellitavad positsioonid ja tagastused",
      //         "description": "Positsioonide olekud ja kogused, tagastused tarnijale ja lattu ning tagastuse tühistamine.",
      //         "url": null,
      //         "durationSeconds": null,
      //         "updatedAt": null
      //       }
      //     },
      //   },
      //   {
      //     id: 9, number: 9,
      //     videos: {
      //       "ru": {
      //         "title": "Счета покупок",
      //         "description": "Поступление товаров и услуг, связь с заказами, кредитные документы и оплаты.",
      //         "url": null,
      //         "durationSeconds": null,
      //         "updatedAt": null
      //       },
      //       "et": {
      //         "title": "Ostuarved",
      //         "description": "Kaupade ja teenuste ostmine, seosed tellimustega, kreeditarved ja maksed.",
      //         "url": null,
      //         "durationSeconds": null,
      //         "updatedAt": null
      //       }
      //     },
      //   },
      //   {
      //     id: 10, number: 10,
      //     videos: {
      //       "ru": {
      //         "title": "Работа со складом",
      //         "description": "Остатки, резервы, движение товаров и инвентаризация.",
      //         "url": null,
      //         "durationSeconds": null,
      //         "updatedAt": null
      //       },
      //       "et": {
      //         "title": "Laohaldus",
      //         "description": "Laoseis, reserveeringud, kaupade liikumine ja inventuur.",
      //         "url": null,
      //         "durationSeconds": null,
      //         "updatedAt": null
      //       }
      //     },
      //   },
      //   {
      //     id: 11, number: 11,
      //     videos: {
      //       "ru": {
      //         "title": "Ценовые предложения и запись",
      //         "description": "Подготовка и отправка предложения, запрос цены и запись клиента.",
      //         "url": null,
      //         "durationSeconds": null,
      //         "updatedAt": null
      //       },
      //       "et": {
      //         "title": "Hinnapakkumised ja broneerimine",
      //         "description": "Hinnapakkumise koostamine ja saatmine, hinnapäring ning kliendi broneering.",
      //         "url": null,
      //         "durationSeconds": null,
      //         "updatedAt": null
      //       }
      //     },
      //   },
      //   {
      //     id: 12, number: 12,
      //     videos: {
      //       "ru": {
      //         "title": "Счета, оплаты и касса",
      //         "description": "Счета продажи и предоплаты, приём оплат и кассовые операции.",
      //         "url": null,
      //         "durationSeconds": null,
      //         "updatedAt": null
      //       },
      //       "et": {
      //         "title": "Arved, maksed ja kassa",
      //         "description": "Müügi- ja ettemaksuarved, maksete vastuvõtmine ja kassatoimingud.",
      //         "url": null,
      //         "durationSeconds": null,
      //         "updatedAt": null
      //       }
      //     },
      //   },
      //   {
      //     id: 13, number: 13,
      //     videos: {
      //       "ru": {
      //         "title": "Статистика",
      //         "description": "Показатели работы, продажи, начисления мастерам и выплаты.",
      //         "url": null,
      //         "durationSeconds": null,
      //         "updatedAt": null
      //       },
      //       "et": {
      //         "title": "Statistika",
      //         "description": "Töönäitajad, müük, tehnikute tasud ja väljamaksed.",
      //         "url": null,
      //         "durationSeconds": null,
      //         "updatedAt": null
      //       }
      //     },
      //   },
      //   {
      //     id: 14, number: 14,
      //     videos: {
      //       "ru": {
      //         "title": "Бухгалтерия",
      //         "description": "Закрытые периоды, настройки интеграции и экспорт документов.",
      //         "url": null,
      //         "durationSeconds": null,
      //         "updatedAt": null
      //       },
      //       "et": {
      //         "title": "Raamatupidamine",
      //         "description": "Suletud perioodid, integratsiooni seadistamine ja dokumentide eksport.",
      //         "url": null,
      //         "durationSeconds": null,
      //         "updatedAt": null
      //       }
      //     },
      //   },
      //   {
      //     id: 15, number: 15,
      //     videos: {
      //       "ru": {
      //         "title": "Несколько локаций",
      //         "description": "Настройка нескольких локаций, сотрудники, доступы и разделение рабочих данных.",
      //         "url": null,
      //         "durationSeconds": null,
      //         "updatedAt": null
      //       },
      //       "et": {
      //         "title": "Mitu asukohta",
      //         "description": "Mitme asukoha seadistamine, töötajad, ligipääsud ja tööandmete eristamine.",
      //         "url": null,
      //         "durationSeconds": null,
      //         "updatedAt": null
      //       }
      //     },
      //   }
      // ],
      tutorials: []
    }
  },
  computed: {
    interfaceLanguage() {
      return String(this.$i18n.locale || 'en').toLowerCase().split(/[-_]/)[0]
    },
    ui() {
      return {
        languageNotice: this.$t('videoTutorialsLanguageNotice'),
        chooseLanguage: this.$t('videoTutorialsChooseLanguageText'),
        comingSoon: this.$t('videoTutorialsComingSoon'),
      }
    },
    interfaceHasVideos() {
      return this.videoLanguages.some(language => language.value === this.interfaceLanguage)
    },
    activeLanguage() {
      return this.selectedLanguage || (this.interfaceHasVideos ? this.interfaceLanguage : null)
    },
    selectedVideoLanguage: {
      get() {
        return this.videoLanguages.find(language => language.value === this.activeLanguage) || null
      },
      set(language) {
        this.selectedLanguage = language?.value || null
      },
    },
    visibleTutorials() {
      if (!this.activeLanguage) return []
      return this.tutorials
          .filter(tutorial => tutorial.videos?.[this.activeLanguage])
          .map(tutorial => ({ ...tutorial, video: tutorial.videos[this.activeLanguage] }))
          .sort((a, b) => a.number - b.number)
    },
  },
  watch: {
    interfaceLanguage() {
      this.selectedLanguage = null
    },
  },
  methods: {
    isPlaceholder(url) {
      return !url || url === '#'
    },
    formatDuration(seconds) {
      if (!Number.isFinite(seconds) || seconds <= 0) return false
      const total = Math.floor(seconds)
      const hours = Math.floor(total / 3600)
      const minutes = Math.floor((total % 3600) / 60)
      const remainder = String(total % 60).padStart(2, '0')
      return hours ? `${hours}:${String(minutes).padStart(2, '0')}:${remainder}` : `${minutes}:${remainder}`
    },
    validDate(value) {
      if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false
      const date = new Date(`${value}T00:00:00Z`)
      return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value
    },
    formatDate(value) {
      if (!this.validDate(value)) return '–'
      return new Intl.DateTimeFormat(['ru', 'et', 'en', 'fi', 'lt', 'lv'].includes(this.interfaceLanguage) ? this.interfaceLanguage : 'en', {
        day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC',
      }).format(new Date(`${value}T00:00:00Z`))
    },
  },
}
</script>

<style scoped lang="scss">
td {
  height: 58px;
}
.tutorial-coming-soon {
  display: inline-block;
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
  background: var(--surface-100, #f1f3f5);
  color: var(--text-color-secondary, #6c757d);
  font-size: 0.85rem;
  white-space: nowrap;
}
</style>